// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { DutchCoronerDto } from 'app/_mapper/dutchcoroner.dto';
import { ForeignCoronerDto } from 'app/_mapper/foreigncoroner.dto';

export class DeathDetailDto {
    @AutoMap() dateOfDeath: string;
    @AutoMap() causeOfDeath: number;
    @AutoMap() isAutopsy: boolean;
    @AutoMap() isPoliceInvolved: boolean;
    @AutoMap() description: string;
    @AutoMap() dutchCoroner: DutchCoronerDto;
    @AutoMap() foreignCoroner: ForeignCoronerDto;
    @AutoMap() dpiFirstName: string;
    @AutoMap() dpiLastName: string;
    @AutoMap() dpiMaidenName: string;
    @AutoMap() dpiDateOfBirth: string;
    @AutoMap() dpiStreetName: string;
    @AutoMap() dpiCity: string;
    @AutoMap() dpiCountry: string;
    @AutoMap() dpiHousseNumber: string;
    @AutoMap() dpiHouseNumberAddition: string;
    @AutoMap() dpiHomeAddress: string;
    @AutoMap() dpiBSN: string;
    @AutoMap() dpiLength: number;
    @AutoMap() dpiWeight: number;
    @AutoMap() dpiBirthPlace: string;
    @AutoMap() dpiProfession: string;
    @AutoMap() dpiReligion: string;
    @AutoMap() dpiWeddingDate: string;
    @AutoMap() dpiPlaceOfMarriae: string;
    @AutoMap() dpiIsFatherAlive: boolean;
    @AutoMap() dpiFatherName: string;
    @AutoMap() dpiIsMotherAlive: boolean;
    @AutoMap() dpiMotherName: string;
    @AutoMap() dpiWithPassport: boolean;
    @AutoMap() dpiHasPassportCopy: boolean;
    @AutoMap() isJewelryTakenOff: boolean;
    @AutoMap() dpiHasLuggage: boolean;
    @AutoMap() dpiLuggageInformation: string;
    @AutoMap() dpiSignature: boolean;
    @AutoMap() kindOfFuneral: number;
    @AutoMap() dsiName: string;
    @AutoMap() dsiDateOfBirth: string;
    @AutoMap() dsiBirthPlace: string;
    @AutoMap() cpiFirstName: string;
    @AutoMap() cpiLastName: string;
    @AutoMap() cpiPhoneNumber: string;
    @AutoMap() cpiSpeaksEnglish: boolean;
}